/**
 * Place catalog nav into the sticky header columns: logo | menu | actions
 * Must mount inside .header__columns (not as a sibling of it), or the menu
 * drops onto a second row under the logo/icons.
 */
(() => {
  const nav = document.querySelector('[data-md-main-nav], .md-main-nav');
  if (!nav || nav.dataset.mdMainNavBound === 'true') return;
  nav.dataset.mdMainNavBound = 'true';

  const sourceSection = nav.closest('.shopify-section') || nav.parentElement;
  let slot = null;

  const findColumns = () =>
    document.querySelector('#header-component .header__row--top .header__columns') ||
    document.querySelector('header-component .header__row--top .header__columns');

  const ensureSlot = (columns) => {
    if (!slot) {
      slot = document.createElement('div');
      slot.className = 'md-main-nav-slot';
      slot.setAttribute('data-md-main-nav-slot', '');
    }

    const center = columns.querySelector('.header__column--center');
    if (center) {
      if (!center.contains(slot)) {
        center.appendChild(slot);
      }
      return;
    }

    slot.classList.add('header__column', 'header__column--center');
    if (!columns.contains(slot)) {
      const right = columns.querySelector('.header__column--right');
      if (right) {
        columns.insertBefore(slot, right);
      } else {
        columns.appendChild(slot);
      }
    }
  };

  const mountDesktop = () => {
    const columns = findColumns();
    if (!columns || !nav) return;

    ensureSlot(columns);

    if (!slot.contains(nav)) {
      slot.appendChild(nav);
    }

    if (sourceSection) {
      sourceSection.classList.add('md-main-nav-section--mounted');
    }
    document.documentElement.classList.add('md-main-nav-in-header');
  };

  const unmountDesktop = () => {
    if (!sourceSection || !nav) return;
    if (!sourceSection.contains(nav)) {
      sourceSection.appendChild(nav);
    }
    sourceSection.classList.remove('md-main-nav-section--mounted');
    document.documentElement.classList.remove('md-main-nav-in-header');
  };

  const sync = () => {
    if (window.matchMedia('(min-width: 990px)').matches) {
      mountDesktop();
    } else {
      unmountDesktop();
    }
  };

  sync();
  window.addEventListener('resize', sync, { passive: true });
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('shopify:section:reorder', sync);
})();
